import { createToastInterface } from 'vue-toastification'
import 'vue-toastification/dist/index.css'

const toastOptions = {
  position: 'top-right',
  timeout: 3000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButton: true,
  closeButton: 'button',
  rtl: false,
  maxToasts: 3,
}

const toast = createToastInterface(toastOptions)

export const showToast = ({ title, message, type = 'success' }) => {
  const toastMessage = `${title}\n${message}`

  switch (type) {
    case 'success':
      toast.success(toastMessage)
      break
    case 'error':
      toast.error(toastMessage)
      break
    case 'warning':
      toast.warning(toastMessage)
      break
    case 'info':
      toast.info(toastMessage)
      break
    default:
      toast(toastMessage)
  }
}

export default toast
